/* eslint-disable no-param-reassign, no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import { logout as logoutAuth } from '../auth/authSlice';

// Priority key values is asociated with Modal display order
// The lower the priority value, the higher the display priority
// e.g., priority 1 will be displayed before priority 2
// isActive key value indicates whether the modal is currently active (visible) or not
// dismissedAt and neverShowAgain can be used to track user interactions with the modal
export const MODAL_ACTIVE_KEY = 'isActive';
export const MODAL_PRIORITY_KEY = 'priority';
export const MODAL_DISMISSED_AT_KEY = 'dismissedAt';
export const MODAL_NEVER_SHOW_AGAIN_KEY = 'neverShowAgain';

const INITIAL_STATE = {
  newSupplier: {
    isActive: false,
    priority: 1,
    dismissedAt: null,
    neverShowAgain: null,
  },
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState: { ...INITIAL_STATE },
  reducers: {
    modifyModal(state, action) {
      const { type, isActive, priority, dismissedAt, neverShowAgain } =
        action.payload;
      if (type in state)
        state[type] = {
          ...state[type],
          ...(dismissedAt !== undefined && { dismissedAt }),
          ...(neverShowAgain !== undefined && { neverShowAgain }),
          ...(isActive !== undefined && { isActive }),
          ...(priority !== undefined && { priority }),
        };
      else console.warn(`Modal type "${type}" is not defined in modalSlice`);
    },
    resetModal(state) {
      state = { ...INITIAL_STATE };
    },
    setActiveModal(state, action) {
      const { type } = action.payload;
      if (type in state) state[type].isActive = true;
      else console.warn(`Modal type "${type}" is not defined in modalSlice`);
    },
    setInactiveModal(state, action) {
      const { type } = action.payload;
      if (type in state) state[type].isActive = false;
      else console.warn(`Modal type "${type}" is not defined in modalSlice`);
    },
    toggleModal(state, action) {
      const { type } = action.payload;
      if (type in state) state[type].isActive = !state[type].isActive;
      else console.warn(`Modal type "${type}" is not defined in modalSlice`);
    },
    changeModalPriority(state, action) {
      const { type, priority } = action.payload;
      if (type in state) state[type].priority = priority;
      else console.warn(`Modal type "${type}" is not defined in modalSlice`);
    },
  },
  extraReducers: (builder) => {
    // eslint-disable-next-line no-return-assign
    builder.addCase(logoutAuth, (state) => (state = { ...INITIAL_STATE }));
  },
});

export const {
  modifyModal,
  resetModal,
  setActiveModal,
  setInactiveModal,
  toggleModal,
  changeModalPriority,
} = modalSlice.actions;

export default modalSlice.reducer;
